<template>
  <main page="page-home">
    <Banner />
    <Infographics />
  </main>
</template>

<script>
// import LFModal from '@/lib/lfmodal.js';

import PageBaseMixin from '@/mixins/PageBase';
import Banner from '@/components/BannerHome';
import Infographics from '@/components/Infographics';
import Html from '@/components/content/Html';

export default {
  name: 'Home',
  components: {Banner, Infographics},
  mixins: [PageBaseMixin],
  title: 'Bienvenida | Escuela de liderazgo',

  data() {
    return {
      infographics: {},
    }
  },

  created(){
    this.$store.commit('modal/setComponent', Html);
  }

}
</script>
